import {
  CATEGORIES_GET,
  RECORDED_CLEAR_CATEGORIES_EPGS,
  RECORDED_CLEAR_CATEGORY_LIST,
  RECORDED_CLEAR_SUBCATEGORIES_EPGS,
  RECORDED_CLEAR_SUBCATEGORY_LIST,
  RECORDED_GET_CATEGORY_EPGS,
  RECORDED_GET_CATEGORY_LIST_NEXT_PAGE,
  RECORDED_GET_SUBCATEGORY_EPGS,
  RECORDED_GET_SUBCATEGORY_LIST_NEXT_PAGE,
  RECORDED_RESET,
  SET_CATEGORIES_OPTIONS
} from 'common/constants/action-types';

const initialState = {
  recorded: {
    categories: {},
    subcategoriesEpgs: {},
    categoriesEpgs: {},
    categoryList: {},
    subcategoryList: {}
  },
  vod: {
    categories: {},
    subcategoriesEpgs: {},
    categoriesEpgs: {},
    categoryList: {},
    subcategoryList: {}
  }
};

export default function (state = initialState, action) {
  const key = action.payload && action.payload.vod ? 'vod' : 'recorded';
  switch (action.type) {
    case CATEGORIES_GET:
      return {
        ...state,
        [key]: {
          ...state[key],
          categories: action.payload.data
        }
      };
    case RECORDED_RESET:
      return {
        ...initialState
      };
    case RECORDED_GET_CATEGORY_EPGS:
      return {
        ...state,
        [key]: {
          ...state[key],
          categoriesEpgs: {
            ...state[key].categoriesEpgs,
            ...action.payload.data
          }
        }
      };
    case RECORDED_CLEAR_CATEGORIES_EPGS:
      return {
        ...state,
        [key]: {
          ...state[key],
          categoriesEpgs: {}
        }
      };
    case RECORDED_GET_SUBCATEGORY_EPGS:
      return {
        ...state,
        [key]: {
          ...state[key],
          subcategoriesEpgs: {
            ...action.payload.data
          }
        }
      };
    case RECORDED_CLEAR_SUBCATEGORIES_EPGS:
      return {
        ...state,
        [key]: {
          ...state[key],
          subcategoriesEpgs: {}
        }
      };
    case RECORDED_GET_CATEGORY_LIST_NEXT_PAGE:
      const { data, id } = action.payload;
      const prevCatData = state[key].categoryList[id] || [];
      const newCatData = data[id];

      const updatedCategory = {
        [id]: newCatData.length > 0 ? [...prevCatData, ...newCatData] : [...prevCatData]
      };
      return {
        ...state,
        [key]: {
          ...state[key],
          categoryList: {
            ...state[key].categoryList,
            ...updatedCategory
          }
        }
      };
    case RECORDED_CLEAR_CATEGORY_LIST:
      return {
        ...state,
        [key]: {
          ...state[key],
          categoryList: {
            ...state[key].categoryList,
            ...{ [action.payload.id]: [] }
          }
        }
      };
    case RECORDED_GET_SUBCATEGORY_LIST_NEXT_PAGE:
      const prevSubCatData = state[key].subcategoriesEpgs[action.payload.id] || [];
      const newSubCatData = action.payload.data[action.payload.id];

      const updatedSubcategory = {
        [action.payload.id]:
          newSubCatData.length > 0 ? [...prevSubCatData, ...newSubCatData] : [...prevSubCatData]
      };
      return {
        ...state,
        [key]: {
          ...state[key],
          subcategoriesEpgs: {
            ...state[key].subcategoriesEpgs,
            ...updatedSubcategory
          }
        }
      };
    case RECORDED_CLEAR_SUBCATEGORY_LIST:
      return {
        ...state,
        [key]: {
          ...state[key],
          subcategoryList: {
            ...state[key].subcategoryList,
            ...{ [action.payload.id]: [] }
          }
        }
      };
    case SET_CATEGORIES_OPTIONS: {
      const options = action.payload?.options;
      return {
        ...state,
        [key]: {
          ...state[key],
          categoriesOptions: {
            ...state[key].categoriesOptions,
            ...options
          }
        }
      }
      break;
    }
    default:
      return state;
  }
}
